const webinarPromoteSection = $('#webinars-promote-section');
const webinarCards = webinarPromoteSection.find('.webinars-list-card');

const setWebinarListCards = () => {
  webinarCards.each(function () {
    const cardPersonParent = $(this).find('.webinar-list-card-photos-parent');
    const cardPersonOverflow = $(this).find('.webinar-list-card-photos-overflow');
    const cardPersonPhotos = $(this).find('.webinar-list-card-multiply-photo');
    const personPhotosCount = cardPersonPhotos.length;
    const photoWidth = pxToVw(cardPersonPhotos.eq(0).outerWidth());
    const photoHeight = pxToVw(cardPersonPhotos.eq(0).outerWidth());
    const photoOffset = isDesktop() ? 2 : isTablet() ? 1.9 : 6.389;
    if (personPhotosCount != 0) {
      cardPersonOverflow.width(
        `${photoWidth * personPhotosCount - (photoWidth - photoOffset) * (personPhotosCount - 1)}vw`
      );
      cardPersonOverflow.height(`${photoHeight}vw`);
      cardPersonPhotos.each(function (index) {
        $(this).css({
          left: `${photoOffset * index}vw`,
          'z-index': `${personPhotosCount * 100 - index}`,
        });
      });
    } else {
      gsap.set(cardPersonParent, { display: 'none' });
    }
  });
};

const webinarCardHover = (card, direction) => {
  const cardImageParent = card.find('.webinars-list-page-image');
  const isBig = card.hasClass('big');
  const toHeight = direction == 1 ? (isBig ? '37.75vw' : '20.875vw') : isBig ? '36.25vw' : '19.375vw';
  gsap.to(cardImageParent, {
    height: toHeight,
    duration: 0.667,
    ease: 'tagInEasing',
    overwrite: 'auto',
  });
};

const removeCardHover = (card) => {
  const cardImageParent = card.find('.webinars-list-page-image');
  gsap.set(cardImageParent, { clearProps: 'all' });
};

const updateCardHover = () => {
  webinarCards.each(function () {
    $(this).off('mouseenter mouseleave');
    if (isDesktop()) {
      $(this).on('mouseenter', () => webinarCardHover($(this), 1));
      $(this).on('mouseleave', () => webinarCardHover($(this), 0));
    }
    removeCardHover($(this));
  });
};

const addwebinarPromoteIn = () => {
  const sectionBtn = webinarPromoteSection.find('.button-parent');
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #959698ff 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionInTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      updateCardHover();
    },
  });

  sectionInTL.add(
    animateSectionTopperIn({
      sectionParent: webinarPromoteSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  webinarCards.each(function (index) {
    sectionInTL.add(elementInAnimationYWOpacity($(this), '15vw', 0, 1, 1, 0.83).play(), 0.1 * index + 0.1);
  });
  addBtnAnimation(sectionBtn, 60, true);

  return sectionInTL;
};

$(window).on('load', () => {
  setWebinarListCards();
  if(isDesktop()){
    let webinarPromoteTL = addwebinarPromoteIn();
    $(window).on('deviceChange', () => {
      const progress = webinarPromoteTL.progress();
      webinarPromoteTL = addwebinarPromoteIn();
      webinarPromoteTL.progress(progress);
    });
    ScrollTrigger.create({
      trigger: webinarPromoteSection,
      start: 'top top+=120%',
      end: 'top top',
      once: true,
      onUpdate: (self) => {
        webinarPromoteTL.progress(self.progress);
      },
    });
  }
});
